// src/lib/theme-provider.tsx
import { lightTheme as lightThemeOptions, legacyTheme as legacyThemeOptions } from "@availity/theme";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { enUS as enUSDate } from "@mui/x-date-pickers/locales";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { jsx, jsxs } from "react/jsx-runtime";
var lightTheme = createTheme(lightThemeOptions);
var legacyTheme = createTheme(legacyThemeOptions);
var themes = {
  lightTheme,
  legacyBS: legacyTheme
};
function ThemeProvider({ children, theme = "lightTheme" }) {
  return /* @__PURE__ */ jsx(
    LocalizationProvider,
    {
      dateAdapter: AdapterDayjs,
      localeText: enUSDate.components.MuiLocalizationProvider.defaultProps.localeText,
      children: /* @__PURE__ */ jsxs(MuiThemeProvider, { theme: themes[theme], children: [
        /* @__PURE__ */ jsx(CssBaseline, {}),
        children
      ] })
    }
  );
}
export {
  ThemeProvider
};
